import { BaseModel } from './BaseModel';

export class EventLog extends BaseModel {
  static get entity() {
    return 'event-log';
  }

  static get fk() {
    return 'event_log_id';
  }

  static fields() {
    return {
      id: this.uid(),
      learning_unit_id: this.attr(null),
      timestamp: this.attr(null),
      message: this.attr(null),
      log_group: this.attr(null),
      created_at: this.attr(null),
      updated_at: this.attr(null),
      delete_at: this.attr(null)
    };
  }

  static apiConfig = {
    actions: {
      fetch(params) {
        return this.get(`/event-logs`, { params });
      }
    }
  };
}

export default EventLog;
